import { produce } from "immer";
import {
  FETCH_BUNDLES,
  FETCH_BUNDLES_SUCCESS,
  FETCH_BUNDLES_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_BUNDLES,
  ADD_BUNDLES_SUCCESS,
  ADD_BUNDLES_FAILURE,
  //
  EDIT_BUNDLES,
  EDIT_BUNDLES_SUCCESS,
  EDIT_BUNDLES_FAILURE,
  //
  DELETE_BUNDLES,
  DELETE_BUNDLES_SUCCESS,
  DELETE_BUNDLES_FAILURE,
  //
  GET_SUBS,
  GET_SUBS_SUCCESS,
  GET_SUBS_FAILURE,
  //
  ADD_SUB,
  ADD_SUB_SUCCESS,
  ADD_SUB_FAILURE,
} from "./constants";

export const initialState = {
  isFetching: false,
  bundleList: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentBundle: {},
  // Delete
  isDeleting: false,
  //
  isFetchingSubs: false,
  subList: [],
  isAddingSub: false,
};

const BundlesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_BUNDLES:
        draft.isFetching = true;
        draft.bundleList = [];
        break;
      case FETCH_BUNDLES_SUCCESS:
        draft.isFetching = false;
        draft.bundleList = action.payload;
        break;
      case FETCH_BUNDLES_FAILURE:
        draft.isFetching = false;
        draft.bundleList = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentBundle = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentBundle = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_BUNDLES:
        draft.isSubmitting = true;
        break;
      case ADD_BUNDLES_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_BUNDLES_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_BUNDLES:
        draft.isSubmitting = true;
        break;
      case EDIT_BUNDLES_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_BUNDLES_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_BUNDLES:
        draft.isDeleting = true;
        break;
      case DELETE_BUNDLES_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_BUNDLES_FAILURE:
        draft.isDeleting = false;
        break;
      // Delete
      case GET_SUBS:
        draft.isFetchingSubs = true;
        draft.subList = [];
        break;
      case GET_SUBS_SUCCESS:
        draft.isFetchingSubs = false;
        draft.subList = action?.payload;
        break;
      case GET_SUBS_FAILURE:
        draft.isFetchingSubs = false;
        draft.subList = [];
        break;
      // Delete
      case ADD_SUB:
        draft.isAddingSub = true;
        break;
      case ADD_SUB_SUCCESS:
        draft.isAddingSub = false;
        break;
      case ADD_SUB_FAILURE:
        draft.isAddingSub = false;
        break;

      default:
        return state;
    }
  });

export default BundlesReducer;
